import React, { FC, lazy } from 'react'
const ProductsWidget = lazy(() => import('./dashboards/products-widget'))
const SuppliersWidget = lazy(() => import('./dashboards/suppliers-widget'))
const Activities = lazy(() => import('./dashboards/activities'))
const SalesChart = lazy(() => import('./dashboards/sales-chart'))
const ProductGroupStats = lazy(() => import('./dashboards/product-group-stats'))
const LastFiveBalance = lazy(() => import('./dashboards/last-five-balance'))
import { PERMISSION_CONSTANTS } from '@/core/constants/common/permission-constants'
import { t } from 'i18next'
import PermissionWrapper from '@/core/wrappers/permission-wrapper'
import SalesQuantityChart from '../supplier/dashboards/sales-quantity-chart'

const RetailerHome: FC = () => (
  <>

    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8 mb-5'>
          <div className='col-xl'>
            <div className='row gx-5 gx-xl-8  mb-xl-8'>
              <div className='col-xl-6'>
                <ProductsWidget
                  className='card-xxl-stretch bg-primary'
                  svgIcon='parcel'
                  titleClass='text-white'
                  descriptionClass='text-white'
                  iconClass='text-white' />
              </div>
              <div className='col-xl-6'>
                <SuppliersWidget
                  className='card-xxl-stretch bg-body'
                  svgIcon='lots-shopping'
                  titleClass='text-gray-900'
                  descriptionClass='text-muted'
                  iconClass='text-success' />
              </div>
            </div>
            {
              <PermissionWrapper permission={PERMISSION_CONSTANTS.DashboardSalesAmount} action="Read">
                <div className='row gx-6 gx-xl-8'>
                  <div className='col-xxl'>
                    <SalesChart
                      className='card-xxl-stretch-100 '
                      chartColor='primary'
                      chartHeight='250px' />
                  </div>
                </div>
              </PermissionWrapper>
            }
            {
              <PermissionWrapper permission={PERMISSION_CONSTANTS.DashboardSalesQuantity} action="Read">
                <div className='row gx-6 gx-xl-8'>
                  <div className='col-xxl'>
                    <SalesQuantityChart
                      className='card-xxl-stretch-100 '
                      chartColor='primary'
                      chartHeight='250px' />
                  </div>
                </div>
              </PermissionWrapper>
            }
            {
              <PermissionWrapper permission={PERMISSION_CONSTANTS.DashboardLastFiveBalance} action="Read">
                <div className='row mt-5 gx-6 gx-xl-8'>
                  <div className='col-xxl'>
                    <LastFiveBalance
                      className='card-xxl-stretch-100 '
                      chartColor='primary'
                      chartHeight='250px' />
                  </div>
                </div>
              </PermissionWrapper>
            }
          </div>
        </div>
      </div>

      <div className='col-xl-4'>
        <div className="card card-flush ">

          <div className="card-header pt-7">

            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold text-gray-900">{t("sales_performance_by_product_group")}</span>
              <span className="text-gray-500 pt-2 fw-semibold fs-6">{t('last_six_month')}</span>
            </h3>

          </div>
          <div className="card-body pt-9">
            <ProductGroupStats />
          </div>
        </div>
      </div>

      <div className='col-xl-4'>
        <div className="card card-flush ">

          <div className="card-header pt-7">

            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold text-gray-900">{t("activities")}</span>
            </h3>

          </div>
          <div className="card-body pt-9">
            <Activities />
          </div>
        </div>
      </div>
    </div>
  </>
)
export default RetailerHome; 
